import {
  TollDetailFormValues,
  TollEditFormValues,
  TollSearchFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
 SETTING - TOLL SEARCH
---------------------------------------------------------------------------------------------*/
export const initialTollSearchForm: TollSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
 SETTING - TOLL EDIT
---------------------------------------------------------------------------------------------*/
export const initialTollEditForm: TollEditFormValues = {
  fromCcm: null,
  toCcm: null,
  price: null,
};

/*-------------------------------------------------------------------------------------------
     SETTING - TOLL - DETAIL
---------------------------------------------------------------------------------------------*/
export const initialTollDetailForm: TollDetailFormValues = {
  id: null,
  fromCcm: null,
  toCcm: null,
  price: null,
};
